module.exports = __webpack_public_path__ + "static/img/pad7.0489541b.png";